export const VATs_options =
[
	{ value: '20', label: '20%' },
	{ value: '10', label: '10%' },
	{ value: '5.5', label: '5.5%' },
	{ value: '0', label: '0%' }
];

export const payment_types =
[
	{ value: 'check', label: 'Chèque' },
	{ value: 'holidays_coupon', label: 'Chèque vacances' },
	{ value: 'bank_transfer', label: 'Virement' },
	{ value: 'credit_note', label: 'Avoir(s)' },
	{ value: 'credit_card', label: 'CB' }
];

export const bill_types =
[
	{ value: 'partner', label: 'Manuelle - Partenaire' },
	{ value: 'EC', label: 'Manuelle - CSE' },
	{ value: 'member', label: 'Manuelle - Membre' },
	{ value: 'EC_order', label: 'Commande - CSE' },
	{ value: 'member_order', label: 'Commande - Membre' }
];

export const bill_payment_status =
[
	{ value: 'pending', label: 'En attente' },
	{ value: 'partially_paid', label: 'Partiellement' },
	{ value: 'paid', label: 'Réglé' }
];

export const roles =
[
	{ value: 'Membre de synergies' },
	{ value: 'Administrateur de CE' },
	{ value: 'Membre de CE' },
	{ value: 'Partenaire' },
	{ value: 'legal_writer', label: 'Partenaire juridique' }
];

export const user_status =
[
	{ value: 'validated', label: 'Activé', color: 'green' },
	{ value: 'pending', label: 'En attente', color: 'red' },
	{ value: 'disabled', label: 'Désactivé', color: 'grey' },
	{ value: 'new', label: 'Récupéré', color: 'blue' },
	{ value: 'imported', label: 'En création', color: 'blue' }
];

export const budget_options =
[
	{
		value: 'none',
		label: 'À la carte'
	},
	{
		value: '1',
		label: 'De 2276 à 3000 €',
		amount: '1190'
	},
	{
		value: '2',
		label: 'De 3001 à 4000 €',
		amount: '1731'
	},
	{
		value: '3',
		label: 'De 4001 à 5000 €',
		amount: '2056'
	},
	{
		value: '4',
		label: 'De 5001 à 6999 €',
		amount: '2605'
	},
	{
		value: '5',
		label: 'De 7000 à 9147 €',
		amount: '3064'
	},
	{
		value: '6',
		label: 'De 9148 à 12.500 €',
		amount: '3872'
	},
	{
		value: '7',
		label: 'De 12.501 à 15.244 €',
		amount: '3985'
	},
	{
		value: '8',
		label: 'De 15.245 à 25.000 €',
		amount: '4852'
	},
	{
		value: '9',
		label: 'De 25.001 à 50.000 €',
		amount: '5184'
	},
	{
		value: '10',
		label: '50.001 et +',
		amount: '7825'
	}
];

export const renewal_status =
{
	pending: 'En attente',
	reminded: 'Relancé',
	stopped: 'Non',
	renewed: 'Oui',
	none: 'Non envoyé'
};